export function getAdvertiseBlockId(containerName, blockLocation, size) {
    return containerName + '--' + blockLocation + '--' + size;
}
